import { CheckIcon } from "@phosphor-icons/react";

export const SuccessCheck = (): React.JSX.Element => (
  <div className="tw:flex tw:size-16 tw:items-center tw:justify-center tw:rounded-full tw:bg-secondary-moss/15">
    <CheckIcon size={32} className="tw:text-secondary-moss" />
  </div>
);
